export default __webpack_public_path__ + "static/minidukan-58efd149f7d2060a1394b4f873abe6f5.svg";